module.exports = {
      id: "ic-btcltc-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-btcltc-usage",
      toString: function () {
        return this.url;
      }
    }